;var getUrlHashVars = (function(window) {
   var vars = {};
   var parts = window.location.href
		.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(m, key, value) {
			vars[key] = value;
			//vars.push([key, value]);
		});
	return vars;
})(window);

